"use client"

import { useEffect, useState } from "react"

interface Props {
  label: string
  targetHash?: string
  heroSelector?: string
}

export default function MobileStickyBottomCTA({
  label,
  targetHash = "#configurator",
  heroSelector = "#hero",
}: Props) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const hero = document.querySelector(heroSelector)
    if (!hero) return
    const obs = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        // Show only after hero has fully scrolled out of view
        setVisible(!entry.isIntersecting)
      },
      { rootMargin: "0px 0px -100px 0px", threshold: 0 }
    )
    obs.observe(hero)
    return () => obs.disconnect()
  }, [heroSelector])

  return (
    <div
      aria-hidden={!visible}
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-stone-200/70 bg-white/95 px-4 pt-3 backdrop-blur-xl transition-transform duration-300 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 12px)" }}
    >
      <a
        href={targetHash}
        data-track="click_mobile_sticky_cta"
        data-track-section="mobile-sticky"
        className="flex h-12 w-full items-center justify-center gap-2 rounded-full text-base font-bold text-white"
        style={{
          background: "linear-gradient(135deg, #fb923c 0%, #ea580c 100%)",
          boxShadow: "0 8px 18px -8px rgba(234,88,12,0.55)",
        }}
      >
        {label}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </a>
    </div>
  )
}
